import customHeaders, { getSpace } from '../../common/headers'
import card_img from './img/card_img.svg'
import ModalWarning from '../../components/Modal/ModalWarning/ModalWarning'
import ModalPostChat from '../../components/Modal/ModalPostChat/ModalPostChat'
import { useNavigate } from 'react-router-dom'
import { RavshanHttps } from '../../fetchUrls'
import { FilterContainer } from '../../components/FilterContainer/FilterContainer'
import { ModalPlanningPost } from '../../components/Modal/ModalPlanningPost/ModalPlanningPost'
import { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { TooltipBlack } from '../../components/Tooltip/TooltipBlack/TooltipBlack'
import {
    DropDownSelector,
    ButtonBasic,
    Tabs,
    InputDynamicWidth,
    RangeBox,
    NoDataContent
} from '@lk-gtcom/ecomlab-components'
import { ButtonsSort } from '../../components/Buttons/BurronsSort/ButtonsSort'
import { TitlePage } from '../../components/TitlePage/TitlePage'
import { SceletonPost } from './SceletonPost/SceletonPost'
import useGeneralStore from '../../store/general'
import InfiniteScroll from "react-infinite-scroll-component"
import { MoonLoader } from 'react-spinners'
import ChatPost from './ChatPost/ChatPost'
import { periodWeek } from '../../common/constant'
import './Post.scss'
import { CommentItem } from '../../components/CommentItem/CommentItem'
import { Comment } from '../../components/Comment/Comment'
import { useShallow } from 'zustand/react/shallow'
import useModal from '../../store/modal'

const btn_tab = [
    { label: 'Посты', value: 'posts'},
    { label: 'Комментарии', value: 'comments'}
];

// ─── Constants ───────────────────────────────────────────────────────────────

const SORT_OPTIONS = [
    { label: <span>A<br />Z</span>, value: 'title' },
    { label: 'По дате создания', value: 'created_at' },
    { label: 'По дате постинга', value: 'posted_at' },
    { label: 'По статусу', value: 'status' },
]

const COMMENTS_LIMIT = 10
const COMMENTS_POLL_INTERVAL = 5000 // мс — интервал long polling новых сообщений

// ─── Helpers ─────────────────────────────────────────────────────────────────

const toLocalDate = (date) => {
    const offsetMs = new Date().getTimezoneOffset() / 60 * -3_600_000
    return new Date(new Date(date).getTime() + offsetMs)
}

const buildCommentTree = (comments, parentId = null) =>
    comments
        .filter((c) => c.reply_to_comment === parentId)
        .map((c) => ({ ...c, replies: buildCommentTree(comments, c.id) }))

// ─── PostCard ────────────────────────────────────────────────────────────────

const PostCard = ({ name, account, created_at, posted_at, image, onClick, status }) => {

    const returnStatus = (status) => {
        if (status === 'posted') return 'post-card__status-active'
        if (status === 'waiting') return 'post-card__status-pending'
        if (status === 'failed') return 'post-card__status-disactive'
    }

    return <div className="post-card" onClick={onClick}>
        <div className="post-card__preview">

            <div className={returnStatus(status)}>{status}</div>

            <div className="post-card__meta">
                <span className="post-card__meta-item">
                    Дата создания:&nbsp;
                    <strong>{created_at ? new Date(created_at).toLocaleDateString('ru-RU') : '—'}</strong>
                </span>
                <span className="post-card__meta-item">
                    Дата публикации:&nbsp;
                    <strong>{posted_at ? toLocalDate(posted_at).toLocaleDateString('ru-RU') : '—'}</strong>
                </span>
            </div>

            <div className="post-card__img-wrap">
                <img
                    className="post-card__img"
                    alt="Превью поста"
                    src={image || card_img}
                    onError={(e) => { e.target.src = card_img }}
                />
            </div>
        </div>

        <div className="post-card__body">
            <h3 className="post-card__title">{name}</h3>
        </div>

        <div className="post-card__footer">
            <TooltipBlack
                text={account?.name}
                child={
                    <img
                        className="post-card__account-icon"
                        src={account?.icon}
                        alt={account?.name}
                    />
                }
            />
        </div>
    </div>
}



// ─── Post (main) ─────────────────────────────────────────────────────────────

const Post = ({
    setIsEditSpace,
    setIsModalCreatingNewSpace
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const navigate = useNavigate();
    const activeTab = useParams()['*'];

    const { setPageValue1, isAuthorSpase } =
        useGeneralStore(
            useShallow((state) => ({
                setPageValue1: state.setPageValue1,
                setCurrentSpace: state.setCurrentSpace,
                isAuthorSpase: state.isAuthorSpase
            }))
        );

    const {
        setIsModalActive
    } = useModal(
        useShallow((state) => ({
            setIsModalActive: state.setIsModalActive
        }))
    );

    const client_id = localStorage.getItem('client_id');

    // — Modal state
    const [showModal, setShowModal] = useState(false)
    const [showModalPost, setShowModalPost] = useState(false)
    const [postType, setPostType] = useState('')

    // — Warning modal
    const [postToDelete, setPostToDelete] = useState({})
    const [warningHeader, setWarningHeader] = useState('')
    const [warningMessage, setWarningMessage] = useState('')
    const [warningApproveText, setWarningApproveText] = useState('')
    const [warningCancelText, setWarningCancelText] = useState('')

    // — Data
    const [posts, setPosts] = useState([])
    const [groups, setGroups] = useState([])
    const [accounts, setAccounts] = useState([])
    const [statuses, setStatuses] = useState([])
    const [platforms, setPlatforms] = useState([])
    const [dialogs, setDialogs] = useState([])
    const [comments, setComments] = useState([])
    const [loading, setLoading] = useState(false)

    // — Pagination for comments
    const [hasMoreComments, setHasMoreComments] = useState(true)
    const [loadingComments, setLoadingComments] = useState(false)
    const isFetchingComments = useRef(false)
    const lastCommentId = useRef(null)

    // — Long polling новых сообщений
    const pollIntervalRef = useRef(null)
    const isPollingComments = useRef(false)

    // — Filters
    const [selectedPlatforms, setSelectedPlatforms] = useState([])
    const [selectedGroup, setSelectedGroup] = useState([])
    const [selectedAccounts, setSelectedAccounts] = useState([])
    const [selectedStatus, setSelectedStatus] = useState({})
    const [date, setDate] = useState(periodWeek())
    const [dateFrom, dateTo] = date

    // — View / sort / search
    const [view, setView] = useState('card')
    const [currentSort, setCurrentSort] = useState(null)
    const [sort, setSort] = useState(null)
    const [searchInput, setSearchInput] = useState('')
    const [isDrop, setIsDrop] = useState(null)

    // — Selected post - используем уникальный идентификатор, который включает username
    const [selectedPostKey, setSelectedPostKey] = useState(null) // { post_id, username, source }
    const [selectedPostContent, setSelectedPostContent] = useState({})

    // — Answer / edit
    const [answerValue, setAnswerValue] = useState('')

    const [currentMessageAnswer, setCurrentMessageAnswer] = useState(null);

    const [currentPost, setCurrentPost] = useState(null)

    const [pageValue, setPageValue] = useState(btn_tab[0].value);

    // ── Fetch: dialogs ──────────────────────────────────────────────────────
    const fetchDialogs = () => {
        fetch('https://portals.ecomru.ru/api/social/dialogs', { method: 'GET', headers })
            .then((res) => { if (!res.ok) throw new Error(); return res.json() })
            .then(setDialogs)
            .catch(console.error)
    }

    // ── Fetch: comments (with pagination) ───────────────────────────────────
    const fetchComments = (source, post_id, username, start_id = null, replace = true) => {
        if (isFetchingComments.current) return
        isFetchingComments.current = true
        setLoadingComments(true)
        let url = `https://portals.ecomru.ru/api/social/dialog/comments?source=${source}&post_id=${post_id}&username=${username}&limit=${COMMENTS_LIMIT}`
        if (start_id) url += `&start_id=${start_id}`
        fetch(url, { method: 'GET', headers })
            .then((res) => { if (!res.ok) throw new Error(); return res.json() })
            .then((data) => {
                if (data) {
                    // Якорь для следующей подгрузки — id самого старого сообщения
                    // именно из только что пришедшей пачки (API отдаёт от новых к старым,
                    // поэтому это последний элемент data, а не merged[0]).
                    const oldestIdInBatch = data?.[data.length - 1]?.id ?? null

                    if (replace) {
                        setComments(data)
                        lastCommentId.current = oldestIdInBatch
                    } else {
                        setComments((prev) => [...prev, ...data])
                        lastCommentId.current = oldestIdInBatch ?? lastCommentId.current
                    }
                    if (data.length < COMMENTS_LIMIT) {
                        setHasMoreComments(false)
                    } else {
                        setHasMoreComments(true)
                    }
                } else {
                    setLoadingComments(false)
                }
            })
            .catch(console.error)
            .finally(() => {
                setLoadingComments(false)
                isFetchingComments.current = false
            })
    }

    // ── Load next page of comments ──────────────────────────────────────────
    const fetchMoreComments = () => {
        if (isFetchingComments.current || !hasMoreComments || !selectedPostKey) return
        const { source, username, post_id } = selectedPostKey
        fetchComments(source, post_id, username, lastCommentId.current, false)
    }

    // ── Long polling: проверка новых сообщений раз в COMMENTS_POLL_INTERVAL ──
    const pollNewComments = () => {
        if (!selectedPostKey || isFetchingComments.current || isPollingComments.current) return
        const { source, post_id, username } = selectedPostKey
        isPollingComments.current = true

        const url = `https://portals.ecomru.ru/api/social/dialog/comments?source=${source}&post_id=${post_id}&username=${username}&limit=${COMMENTS_LIMIT}`

        fetch(url, { method: 'GET', headers })
            .then((res) => { if (!res.ok) throw new Error(); return res.json() })
            .then((data) => {
                if (!data || !data.length) return

                setComments((prev) => {
                    const existingIds = new Set(prev.map((c) => c.id))
                    const newItems = data.filter((c) => !existingIds.has(c.id))
                    if (!newItems.length) return prev
                    return [...newItems, ...prev]
                })
            })
            .catch(console.error)
            .finally(() => {
                isPollingComments.current = false
            })
    }

    // ── Fetch: filter options ───────────────────────────────────────────────
    const fetchFilterOptions = (signal) => {
        fetch(`${RavshanHttps}/api/social/filters_posts`, { method: 'GET', headers, signal })
            .then((res) => { if (!res.ok) throw new Error(); return res.json() })
            .then(([{ statuses, platforms, groups }]) => {
                setGroups(groups)
                setPlatforms(platforms)
                setStatuses(statuses)
            })
            .catch(console.error)
    }

    // ── Fetch: posts list ───────────────────────────────────────────────────
    const fetchPosts = (signal) => {
        setLoading(true)
        const body = JSON.stringify({
            group_id: selectedGroup?.value,
            status: selectedStatus?.value,
            account_ids: selectedAccounts?.map((el) => el?.value),
            platform: selectedPlatforms?.value ? [selectedPlatforms.value] : [],
            start_date: new Date(dateFrom),
            end_date: new Date(dateTo),
            group_name: selectedGroup?.label,
            order_param: currentSort?.value,
            order_param_direction: sort === 'ASC' ? 'asc' : 'desc',
            search: searchInput,
        })
        fetch(`${RavshanHttps}/api/social/posts`, { body, method: 'POST', headers, signal })
            .then((res) => { if (!res.ok) throw new Error(); setPosts([]); return res.json() })
            .then((json) => { if (json) setPosts(json) })
            .catch(console.error)
            .finally(() => setLoading(false))
    }

    // ── Fetch: single post ──────────────────────────────────────────────────
    const fetchPostDetail = () => {
        setSelectedPostContent({})
        if (!selectedPostKey) {
            setSelectedPostContent({})
            return
        }
        const { post_id } = selectedPostKey
        fetch(`${RavshanHttps}/api/social/get_detail_post?post_id=${post_id}`, { method: 'GET', headers })
            .then(async (res) => {
                if (!res.ok) { const err = await res.json(); throw new Error(JSON.stringify(err)) }
                return res.json()
            })
            .then((json) => { if (json) setSelectedPostContent(json) })
            .catch(console.error)
            .finally(() => setLoading(false))
    }

    // ── Fetch: accounts ─────────────────────────────────────────────────────
    const fetchAccounts = () => {
        const body = JSON.stringify({
            page: 1, limit: 10, search: '',
            status: 'active', mp_name: 'all',
            order_param: 'name', order_param_direction: 'asc',
        })
        fetch(`${RavshanHttps}/api/social/get_accounts`, { body, method: 'POST', headers })
            .then((res) => { if (!res.ok) throw new Error(); return res.json() })
            .then((json) =>
                setAccounts(json.map((el) => ({
                    label: el[0].name,
                    icon: el[0].icon_link,
                    value: el[0].id,
                })))
            )
            .catch(console.error)
    }

    // Ответ на комментарий
    const fetchReplyComment = (comment, message) => {
        console.log(message)
        setLoading(true)
        const url = `https://portals.ecomru.ru/api/social/answer_on_comment`

        const body = JSON.stringify({
            params: { ...comment, message: message }
        })

        const abortController = new AbortController();

        const options = {
            body,
            method: 'POST',
            headers,
            signal: abortController.signal
        }

        fetch(url, options)
            .then(res => res.json())
            .then(json => {
                setTimeout(() => {
                    fetchComments(currentPost?.source, currentPost?.post_id, currentPost?.username)
                }, 500)
            })
            .catch(err => console.error(err))
            .finally(() => setLoading(false))
    }

    // ── Warning helpers ─────────────────────────────────────────────────────
    const clearWarning = () => {
        setWarningHeader('')
        setWarningMessage('')
        setWarningApproveText('')
        setWarningCancelText('')
        setPostToDelete({})
    }



    // ── Handle post selection ───────────────────────────────────────────────
    const handlePostSelect = (post_id, source, username) => {
        const newKey = { post_id, source, username }
        const keyString = `${post_id}-${source}-${username}`
        const currentKeyString = selectedPostKey ? `${selectedPostKey.post_id}-${selectedPostKey.source}-${selectedPostKey.username}` : null

        // Если выбран тот же пост, снимаем выделение
        if (currentKeyString === keyString) {
            setSelectedPostKey(null)
            setSelectedPostContent({})
            setComments([])
            setHasMoreComments(true)
            isFetchingComments.current = false
            lastCommentId.current = null
            return
        }

        // Иначе выбираем новый пост
        setComments([])
        setHasMoreComments(true)
        isFetchingComments.current = false
        lastCommentId.current = null
        setSelectedPostKey(newKey)
        setCurrentPost({ source, post_id, username })
        fetchComments(source, post_id, username, null, true)
    }

    // ── Effects ─────────────────────────────────────────────────────────────
    useEffect(() => { fetchDialogs() }, [])
    useEffect(() => { fetchFilterOptions() }, [])
    useEffect(() => {
        fetchAccounts()
        const ctrl = new AbortController()
        return () => ctrl.abort()
    }, [selectedSpace])

    useEffect(() => {
        fetchPosts()
    }, [selectedSpace, selectedGroup, selectedPlatforms, selectedAccounts,
        selectedStatus, searchInput, currentSort, sort, date])

    useEffect(() => { fetchPostDetail() }, [selectedSpace, selectedPostKey])
    useEffect(() => setPageValue(activeTab), [activeTab]);

    // ── Long polling новых сообщений раз в 5 секунд ──────────────────────────
    useEffect(() => {
        // Останавливаем предыдущий интервал при смене диалога/вкладки
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current)
            pollIntervalRef.current = null
        }

        if (pageValue === 'comments' && selectedPostKey) {
            pollIntervalRef.current = setInterval(() => {
                pollNewComments()
            }, COMMENTS_POLL_INTERVAL)
        }

        return () => {
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current)
                pollIntervalRef.current = null
            }
        }
    }, [selectedPostKey, pageValue])

    // ── Render ──────────────────────────────────────────────────────────────
    return (
        <>
            {/* ── Modals ── */}
            {showModal && (
                <ModalPlanningPost
                    groups={groups}
                    selectedGroupFilter={selectedGroup}
                    postType={postType}
                    status={selectedStatus}
                    setShowModal={setShowModal}
                    onClose={() => { fetchPosts(null); setShowModal(false) }}
                />
            )}

            {showModalPost && (
                <ModalPostChat
                    selectedPostContent={selectedPostContent}
                    setSelectedPostContent={setSelectedPostContent}
                    setIsModal={setShowModalPost}
                />
            )}

            {Object.keys(postToDelete).length > 0 && (
                <ModalWarning
                    headerText={warningHeader}
                    messageText={warningMessage}
                    approveButtonText={warningApproveText}
                    cancelButtonText={warningCancelText}
                    onApproveClick={clearWarning}
                    onCancelClick={clearWarning}
                />
            )}

            {/* ── Page ── */}
            <div className="post">

                <div className="post__panel-top">
                    <TitlePage title="Посты" />

                    <ButtonBasic
                        green
                        text={isAuthorSpase ? '+ Добавить подключение' : 'Посмотреть подключения'}
                        width='auto'
                        onClick={() => {
                            if (isAuthorSpase) {
                                setIsModalActive(true)
                            } else {
                                navigate('/settings/space');
                                setIsEditSpace(true)
                                setPageValue1('settings')
                                setIsModalCreatingNewSpace(true);    
                            }
                        }}
                    />
                </div>

                <Tabs tabs={btn_tab} pageValue={pageValue} />

                {/* ── Card view ── */}
                {pageValue === 'posts' && <>
                    <ButtonBasic
                        onClick={() => { setPostType('post'); setShowModal(true) }}
                        positionIcon="right"
                        text="+ Новый пост"
                    />

                    <FilterContainer
                        onReset={() => {
                            setSelectedPlatforms([])
                            setSelectedGroup([])
                            setSelectedStatus([])
                        }}
                    >
                        <DropDownSelector
                            options_prop={platforms}
                            state={selectedPlatforms}
                            setState={setSelectedPlatforms}
                            placeholder="Площадка"
                        />
                        <DropDownSelector
                            options_prop={groups}
                            state={selectedGroup}
                            setState={setSelectedGroup}
                            placeholder="Группа"
                        />
                        <DropDownSelector
                            options_prop={accounts}
                            state={selectedAccounts}
                            setState={setSelectedAccounts}
                            placeholder="Аккаунты"
                            multi
                        />
                        <DropDownSelector
                            options_prop={statuses}
                            state={selectedStatus}
                            setState={setSelectedStatus}
                            placeholder="Статус"
                        />
                    </FilterContainer>

                    <div className="post__toolbar">
                        <ButtonsSort
                            btnSort={SORT_OPTIONS}
                            sort={sort}
                            setSort={setSort}
                            currentSort={currentSort}
                            setCurrentSort={setCurrentSort}
                        />

                        <InputDynamicWidth
                            position="left"
                            maxWidth="100%"
                            isOpen
                            placeholder="Поиск"
                            onChange={(value) => setSearchInput(value)}
                        />
                        <RangeBox date={date} hideBtnGroup setDate={setDate} hedeGroupBtn />
                    </div>



                    <div className="post__card-grid">
                        {loading
                            ? [...Array(8)].map((_, i) => <SceletonPost key={i} />)
                            : posts.length
                                ? posts.map((post) => (
                                    <PostCard
                                        key={post.id}
                                        {...post}
                                        name={post.title}
                                        image={post.post_img}
                                        onClick={() => {
                                            setSelectedPostKey({
                                                post_id: post.id,
                                                source: post.source,
                                                username: post.username
                                            });
                                            setShowModalPost(true)
                                            // navigate('./comments')
                                        }}
                                    />
                                ))
                                : (
                                    <NoDataContent
                                        title="Нет постов"
                                        description="Создайте новый пост, чтобы пользоваться всеми инструментами сервиса"
                                    />
                                )
                        }
                    </div>
                </>

                }

                {/* ── Chat view ── */}
                {pageValue === 'comments' && (
                    dialogs?.length ?
                        <div className="chat-post-v2">
                            {/* Column 1 — post list */}
                            <aside className="chat-post-v2__sidebar">
                                <div className="chat-post-v2__col-header">
                                    <TitlePage medium title='Список постов' />
                                </div>
                                <div className="chat-post-v2__col-body">
                                    {dialogs?.map(({ source, post_id, username, title, created_at, account_name }) => {
                                        const isActive = selectedPostKey &&
                                            selectedPostKey.post_id === post_id &&
                                            selectedPostKey.source === source &&
                                            selectedPostKey.username === username;

                                        return (
                                            <div
                                                key={`${post_id}-${source}-${username}`}
                                                className={`dialog-item ${isActive ? 'dialog-item--active' : ''}`}
                                                onClick={() => handlePostSelect(post_id, source, username)}
                                            >
                                                <div className={`dialog-item__avatar dialog-item__avatar--${source}`}>
                                                    {source === 'external_chat' ? 'EC' : source.toUpperCase()}
                                                </div>

                                                <div className="dialog-item__info">
                                                    <div className="dialog-item__top-row">
                                                        <span className="dialog-item__username">{username || 'Без имени'}</span>
                                                        <span className="dialog-item__date">
                                                            {new Date(created_at).toLocaleDateString('ru-RU', {
                                                                day: '2-digit', month: '2-digit', year: '2-digit'
                                                            })}
                                                        </span>
                                                    </div>

                                                    <span className="dialog-item__title">{title || 'Без названия'}</span>

                                                    <div className="dialog-item__bottom-row">
                                                        <span className="dialog-item__account">{account_name}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </aside>

                            {/* Column 2 — comments */}
                            <section className="chat-post-v2__comments">
                                {(loadingComments && !comments?.length) ?
                                    <div className='chat-post-v2__loader'>
                                        <MoonLoader
                                            color="#7b7b7b"
                                            speedMultiplier={0.5}
                                        />
                                    </div>
                                    :
                                    (!selectedPostContent?.title ?
                                        <NoDataContent
                                            height='100%'
                                            description={'Выберите пост, чтобы просмотреть его данные'}
                                            border={false}
                                        />
                                        :
                                        <>
                                            {selectedPostContent?.title ? <aside className="chat-post-v2__post-detail">
                                                <div className="chat-post-v2__col-header">
                                                    <div className="chat-post-v2__post-header">
                                                        <TitlePage
                                                            medium
                                                            title={'Пост'}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="chat-post-v2__col-body">
                                                    <ChatPost
                                                        post={selectedPostContent}
                                                        placeholderText="Выберите пост, чтобы просмотреть его данные"
                                                    />
                                                </div>
                                            </aside> : null}
                                        </>

                                    )}

                                {comments?.length ? <div className="chat-post-v2__col-body-comments">
                                    <div
                                        className="chat-post-v2__comment-scroll"
                                        id="commentsScrollDiv"
                                        style={{
                                            overflowY: 'auto',
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column-reverse'
                                        }}
                                    >

                                        <InfiniteScroll
                                            scrollableTarget="commentsScrollDiv"
                                            dataLength={comments?.length}
                                            next={() => {
                                                 if (!loadingComments) {
                                                 fetchMoreComments()  
                                            }}}
                                            inverse={true}
                                            hasMore={hasMoreComments}
                                            loader={
                                                <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0' }}>
                                                    <MoonLoader
                                                        size={24}
                                                        color="#7b7b7b"
                                                        speedMultiplier={0.5}
                                                    />
                                                </div>
                                            }
                                             style={{ display: 'flex', flexDirection: 'column-reverse' }}
                                             initialScrollY={0}
                                        >
                                            {comments?.map((c) => {
                                                // <CommentPost
                                                //     key={c.id}
                                                //     comment={c}
                                                //     account_id={selectedPostContent?.account?.id || 0}
                                                //     post_id={selectedPostKey?.post_id}
                                                //     update={fetchComments}
                                                //     source={selectedPostKey?.source}
                                                //     username={selectedPostKey?.username}
                                                // />

                                                const props = {
                                                    comment_data: c,
                                                    messageData: {
                                                        created_at: c?.created_at,
                                                        text: c?.message,
                                                        author: { name: c?.author?.name, login: c?.author?.login, color: c?.author?.color || '#4285f4' },
                                                        files: null,
                                                        message_id: c?.account_id,
                                                        parent_message: c?.parent_message,
                                                        isAuthor: c?.is_my_message,
                                                    },
                                                    date: c?.created_at,
                                                    ...c?.parent_message ?
                                                        {
                                                            reply_to: {
                                                                text: c?.parent_message,
                                                                author: c?.author_parent_message || 'Неизвестный'
                                                            }
                                                        } : {}

                                                }
                                                return <CommentItem
                                                    key={c?.id ?? (c?.account_id + '-' + c?.parent_message)}
                                                    {...props}
                                                    message_id={c?.account_id}
                                                    currentMessageAnswer={currentMessageAnswer}
                                                    setCurrentMessageAnswer={setCurrentMessageAnswer}
                                                    hideToolsPanel={true}
                                                />
                                            })}
                                        </InfiniteScroll>


                                    </div>

                                </div> : null}

                                <div className='chat-post-v2__comment-box'>
                                    <Comment
                                        // saveFile={saveFileMessage}
                                        // setSaveFile={setSaveFileMessage}
                                        type={'comments'}
                                        setComments={setAnswerValue}
                                        createFunc={() => { }}
                                        fetchDeleteFiles={() => { }}
                                        currentMessageAnswer={currentMessageAnswer}
                                        setCurrentMessageAnswer={setCurrentMessageAnswer}
                                        // name={''}
                                        // email={email}
                                        // color={currentUserColor}
                                        disabled={!currentMessageAnswer}
                                        fetchUpdateComms={() => { }}
                                        fetchComments={fetchReplyComment}
                                        plainTextOnly
                                    />
                                </div>

                            </section>

                            {/* Column 3 — post detail */}

                        </div>
                        :
                        <NoDataContent
                            title="Нет комментариев"
                            description="Создайте новый пост, чтобы пользоваться всеми инструментами сервиса"
                        />
                )}
            </div>
        </>
    )
}

export { Post }
